import { render, staticRenderFns } from "./SceneManagementVulkan.vue?vue&type=template&id=6e0fed08&scoped=true"
import script from "./SceneManagementVulkan.vue?vue&type=script&lang=js"
export * from "./SceneManagementVulkan.vue?vue&type=script&lang=js"
import style0 from "./SceneManagementVulkan.vue?vue&type=style&index=0&id=6e0fed08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0fed08",
  null
  
)

export default component.exports